import React from 'react'
import {
  node, string, oneOfType, elementType,
} from 'prop-types'

function FeatureItem({ title = '', description = '', Icon = null }) {
  return (
    <li className="custom-solutions__features-item cgt-legacy-text-default text-light-grey">
      {Icon && <Icon width={16} height={24} />}
      <span>
        {title && <span className="text-white font-weight-600">{title}</span>}
        {description && ` - ${description}`}
      </span>
    </li>
  )
}

FeatureItem.propTypes = {
  title: string,
  description: string,
  Icon: oneOfType([elementType, node]),
}

export default FeatureItem
